import {NameValueDTO} from '../../common/models/NameValueDTO';
import {BaseDTO} from '../../common/models/BaseDTO';

export class BankAccountDTO extends BaseDTO {
  bankAccountId: number;
  name: string;
  accountNumber: string;
  ibanNumber: string;
  branchRoutingNumber: number;
  currency: NameValueDTO;
  bank: NameValueDTO;
  location: NameValueDTO;
  bankAccountType: NameValueDTO;
  payer: NameValueDTO;
}
